export default "__VITE_ASSET__HWbVbArO__"